import { getAnalyticsDataFromCookies } from "@common/analytics/ga4";
import { Intercom, showArticle, update } from "@intercom/messenger-js-sdk";

import { UserData, Workspace } from "../models";

interface HelpCenterArticle {
  url: string;
  id: number;
}

export const bootIntercom = (appId: string) => {
  if (!appId) return;
  Intercom({ app_id: appId });
};

export const identifyIntercom = (user?: Partial<UserData>, workspaces?: Workspace[], currentWorkspace?: Workspace) => {
  if (!window.Intercom) return;
  const workspace = currentWorkspace ?? workspaces?.[0];
  const utmParams = getAnalyticsDataFromCookies();
  update({
    ...(user?.id && { user_id: user.id }),
    ...(user?.email && { email: user.email }),
    ...(user?.name && { name: user.name }),
    ...(workspace && { company: { company_id: workspace.id, name: workspace.name } }),
    ...utmParams,
  });
};

export const showIntercomArticle = (article: HelpCenterArticle) => {
  showArticle(String(article.id));
};
